import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../common/Modal/Modal';
import APLabelWithText from '../common/APLabelWithText';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { formatDateTime } from '../../helpers/dateHelper';
import { buyValue } from '../../constants/sendOrder/orderEntryFormConstants';
import { formatNumberToLocale } from '../../helpers/numberFormatter';
import { getOrderNet } from '../../helpers/orderHelper';
import './ConfirmBlockTradeModalComponent.css';
var bemClasses = getBEMClasses('confirm-block-trade-modal');
var ConfirmBlockTradeModal = function ConfirmBlockTradeModal(props, context) {
  var formObj = props.formObj,
    selectedInstrument = props.selectedInstrument,
    isOpen = props.isOpen,
    close = props.close,
    confirmReport = props.confirmReport,
    feeSymbol = props.feeSymbol,
    orderTotal = props.orderTotal,
    useNewForm = props.useNewForm;
  var isBuySide = formObj.values.side === buyValue;
  var boughtProductSymbol = isBuySide ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol;
  var soldProductSymbol = isBuySide ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;
  var items = [{
    label: context.t('Instrument'),
    text: '' + selectedInstrument.Symbol
  }, {
    label: context.t('Counterparty'),
    text: '' + (formObj.values.counterparty ? formObj.values.counterparty : '-')
  }, {
    label: context.t('Locked in'),
    text: '' + (formObj.values.lockedIn ? context.t('Yes') : context.t('No'))
  }, {
    label: context.t(useNewForm ? 'Quantity' : 'Product Bought'),
    text: formObj.values.quantity + ' ' + boughtProductSymbol
  }, {
    label: context.t(useNewForm ? 'Price' : 'Product Sold'),
    text: formObj.values.price + ' ' + soldProductSymbol
  }, {
    label: context.t('Fee'),
    text: formatNumberToLocale(formObj.values.fee.OrderFee, feeSymbol)
  }, {
    label: context.t('Final Amount'),
    text: getOrderNet(formObj, selectedInstrument, orderTotal, false)
  }, {
    label: context.t('Final Value'),
    text: formatNumberToLocale(useNewForm ? formObj.values.price * formObj.values.quantity : formObj.values.price, soldProductSymbol)
  }];
  return React.createElement(Modal, {
    isOpen: isOpen,
    title: context.t('Confirm Block Trade'),
    close: close,
    footer: {
      buttonText: isBuySide ? context.t('Confirm Buy Order') : context.t('Confirm Sell Order'),
      buttonStyle: isBuySide ? 'additive' : 'subtractive',
      onClick: function onClick() {
        return confirmReport(formObj.values);
      }
    },
    customClass: bemClasses(formObj.values.side === buyValue ? 'bought' : 'sold')
  }, React.createElement('div', {
    className: bemClasses()
  }, items.map(function (item) {
    return React.createElement(APLabelWithText, {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  }), React.createElement(APLabelWithText, {
    label: context.t('Date') + ':',
    text: formatDateTime(new Date()),
    customClass: bemClasses()
  })));
};
ConfirmBlockTradeModal.propTypes = {
  formObj: PropTypes.object.isRequired,
  selectedInstrument: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  confirmReport: PropTypes.func.isRequired
};
ConfirmBlockTradeModal.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ConfirmBlockTradeModal;